/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */

import { SaveStateFixer } from './SaveStateFixer';
import { FriendshipChest_DataManager } from './Windows/FriendshipChest/FriendshipChest_DataManager';
import MapChestDataManager from '../Services/OMT/dataTracking/mapChest/MapChestDataManager';
import { FortuneCookieDataManager } from '../Services/OMT/dataTracking/fortuneCookie/FortuneCookieDataManager';
import { LevelType } from './GameState/Managers/GameEnums';

const DATA_KEY = 'gmdatastring-cc2';

/*
   _____                  _____ _        _
  / ____|                / ____| |      | |
 | (___   __ ___   _____| (___ | |_ __ _| |_ ___
  \___ \ / _` \ \ / / _ \\___ \| __/ _` | __/ _ \
  ____) | (_| |\ V /  __/____) | || (_| | ||  __/
 |_____/ \__,_| \_/ \___|_____/ \__\__,_|\__\___|
*/

/**
 * Save State Class
 */
class SaveState {
  /**
   * constructor
   */
  constructor() {
    this._saveStateFixer = new SaveStateFixer();
    this.friendshipChestDataManager = new FriendshipChest_DataManager(); // Is accessed outside of SaveState. Do not change
    this.fortuneCookieDataManager = new FortuneCookieDataManager();
    this.mapChestDataManager = new MapChestDataManager();
    this._progressWasRestored = false;
    this._runningCoinTotal = 0;
    this._refillRate = Math.floor(G.json.settings.refillRateMin * 60000);
    this._defineSingals();
  }

  /**
   * get the data key
   * @returns {string} userData key
   */
  get dataKey() { return DATA_KEY; }

  /**
   * define event signals
   */
  _defineSingals() {
    this.signals = {
      onGateOpened: new Phaser.Signal(),
      onLifeAmountChanged: new Phaser.Signal(),
      onBoosterBought: new Phaser.Signal(),
      onBoosterUsed: new Phaser.Signal(),
    };
  }

  /**
   * make new / default data Object
   */
  _makeNewDataObject() {
    const obj = {
      coins: G.json.settings.coinsOnStart,
      lives: G.json.settings.livesOnStart,
      lastRefillDate: Date.now(),
      lastDaily: Date.now(),
      freeSpin: true,
      levels: [],
      points: [],
      retryCounts: {},
      gates: [],
      boosters: [],
      finishedTutorials: [],
      chestReferals: [],
      startBoosterAnim: [true, true, true, true],
      mute: false,
      muteFx: false,
      cWinCount: 0,
      highestCWinCount: 0,
      version: 1,
      mysteryGift: {
        endOfLastStreak: 0,
        gifts: ['spiral', 'vertical', 'horizontal', 'cross'],
        streak: 0,
        duringLevel: false,
      },
      a2uSchedule: [],
    };
    for (let i = 0; i < 10; i++) {
      obj.boosters[i] = G.json.settings.boostersOnStart;
    }
    return obj;
  }

  /**
   * Initialie the save state
   * @param {Object} data
   */
  _init(userData) {
    // keep these as != dont change to !==
    const dataAvailable = userData != null && userData.levels != null;
    this.data = dataAvailable ? Object.assign(this._makeNewDataObject(), userData) : this._makeNewDataObject();
    this.sessionData = {}; // Unsaved session data.
    this.enforceBoosterCaps();

    if (dataAvailable) { // returning user
      if (this.getLastPassedLevelNr() > 3) {
        this.data.sawDailyTut = true;
      }
    } else if (G.firstTime !== false) { // flag as a first time user if value not already set.
      G.firstTime = true;
    }

    this._initLoginStatsTracker();
    this._mysteryGift_checkData();
    this._checkCWinCountData();
    this._initWallClockEvents();

    G.soundManager.setSoundEnabled(G.MuteReason.UserChoice, !this.data.muteFx);
    G.soundManager.setMusicEnabled(G.MuteReason.UserChoice, !this.data.mute);

    this.data.starsAtSessionStart = this.getAllStars();
    this.data.isHomeScreenPopupSeen = false;

    if (this.data.allowHints === undefined || G.OMTsettings.FTUXSettings === undefined) {
      this.data.allowHints = true;
    }

    if (OMT.feature.getFeatureFriendshipChest(false)) {
      this.friendshipChest_initData();
    }

    this.fortuneCookie_initData(); // Will init if the event is true

    // track new player
    if (G.firstTime) {
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.NewUserSource, 1, {
        source: OMT.envData.entryPoint,
        entry_point: OMT.envData.entryPoint,
      });
    }
  }

  /**
   * init the wall clock event + set signals
   */
  _initWallClockEvents() {
    setInterval(() => {
      G.sb('onWallClockTimeUpdate').dispatch(Date.now());
    }, 1000);
    G.sb('onWallClockTimeUpdate').addPermanent(this._onTick, this, 99);
  }

  /**
   * init dynamic map chest data / chest migration.
   */
  initMapChestData() { // Called from Preloader
    if (!this.data.mapChestData) {
      this.data.mapChestData = {};
    }
    this.mapChestDataManager.init(this.data.mapChestData, this.data.mapChests !== undefined && this.data.mapChests.length > 0);
    if (this.data.mapChestCap) {
      this.mapChestDataManager.setMapChestCap(this.data.mapChestCap);
      delete this.data.mapChestCap;
    }
    if (this.data.mapChests) {
      delete this.data.mapChests;
    }
  }

  /**
   * iniitialize and load data
   */
  async initLoadData() {
    const data = OMT.userData.getUserData(DATA_KEY);
    this._init(data);
  }

  /**
   * Reset services, such as DDNA, tracking, and scheduled bot messages
   */
  async _resetServices() {
    if (DDNA.tracking.enabled) DDNA.tracking.clearQueueFromLocalStorage();
    OMT.platformTracking.clearFTUData();
    await OMT.notifications.unscheduleAllGameTriggeredMessages('both');
  }

  /**
   * reset OMT game data for the user
   */
  async resetOMTData() {
    await this._resetServices();
    await OMT.userData.clearAllData(false);
  }

  /**
   * reset OMT + Legacy COOK data if it exists
   */
  async resetAllData() {
    await this._resetServices();
    await OMT.userData.clearAllData(true);
  }

  /**
   * for externally setting data on the save data
   * @param {string} key
   * @param {*} value
   */
  setGameData(key, value) {
    if (!this.data.gameData) {
      this.data.gameData = {};
    }

    this.data.gameData[key] = value;
    this.save();
  }

  /**
   * get esternally saved game data by key
   * @param {string} key
   */
  getGameData(key) {
    if (!this.data.gameData) {
      this.data.gameData = {};
    }
    return this.data.gameData[key];
  }

  /**
   * check if the daily challenge is currently availabe to the user
   */
  isChallengeAvailable() {
    if (this.data.lastChallengeTry === undefined) this.data.lastChallengeTry = 0;
    const dateNow = new Date();
    const lastTryDate = new Date(this.data.lastChallengeTry);
    let result = false;
    // in case of tempering with data
    if (dateNow.getTime() > lastTryDate.getTime() && dateNow.toDateString() !== lastTryDate.toDateString()) {
      this.data.challengeCompleted = false;
      result = true;
    }
    if (this.data.rewardedChallenge && !this.data.challengeCompleted) result = true;
    if (result) this.data.dailyChalStars = 0;
    return result;
  }

  /**
   * get total daily challenge stars
   * @param {number} st
   * @returns {number}
   */
  getChallengeStars() {
    if (!this.data.dailyChalStars) this.data.dailyChalStars = 0;
    return this.data.dailyChalStars;
  }

  /**
   * add to daily challenge stars
   * @param {number} st
   */
  accumulateChallengeStars(st) {
    if (!this.data.dailyChalStars) this.data.dailyChalStars = 0;
    this.data.dailyChalStars += st;
    if (this.data.dailyChalStars > 3) this.data.dailyChalStars = 3;
  }

  /**
   * start daily challenge
   */
  startChallenge() {
    if (this.data.rewardedChallenge) this.data.rewardedChallenge = false;
    else this.data.lastChallengeTry = Date.now();
    this.save();
  }

  /**
   * mark the daily challenge completed
   */
  markChallengeCompleted() {
    this.data.challengeCompleted = true;
  }

  /**
   * check if challenge is completed
   * @returns {boolean}
   */
  isChallengeCompleted() {
    return this.data.challengeCompleted;
  }

  /**
   * gives the player an additional Chance to do the daily challenge
   */
  enableRewardedChallenge() {
    this.data.rewardedChallenge = true;
    this.save();
  }

  /**
   * get time to next daily challenge
   * @returns {number} time in milliseconds
   */
  getTimeToNextChallenge() {
    if (this.data.lastChallengeTry === undefined) this.data.lastChallengeTry = 0;
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const nextDateStamp = date.getTime() + 24 * 60 * 60 * 1000;
    return (nextDateStamp - Date.now());
  }

  /**
   * get lvl Object for next daily challenge
   * @returns {Object} lvl Object
   */
  getDailyChallengeLevel() {
    // seeding the rng with the current day.
    game.rnd.sow([Math.floor(Date.now() / (1000 * 60 * 60 * 24))]);

    // go through all the levels and pick out the hard ones
    const hardLevels = [];
    for (let i = 0; i < G.Helpers.levelDataMgr.getNumberOfLevels(); i++) {
      const lvl = G.Helpers.levelDataMgr.getLevelByIndex(i);
      if (lvl.showAsHard) {
        hardLevels.push(i);
      }
    }

    // pick a random lvl from those hard levels (from the rng seeded with the current day)
    const lvlIndex = game.rnd.between(0, hardLevels.length - 1);

    // clone the level so we only affect the daily challenge version
    const lvl = G.Utils.clone(G.Helpers.levelDataMgr.getLevelByIndex(hardLevels[lvlIndex]));
    lvl.lvlNumber = lvlIndex + 1;
    lvl.moves -= 3;
    // remove tutorial as it can crash when booster is not unlocked
    if (lvl.tutID) lvl.tutID = null;
    return lvl;
  }

  /**
   * get the time to the next special deal
   * @returns {number} time in milliseconds
   */
  getTimeToNextSpecialDeal() {
    if (!this.data.lastSpecialDeal) {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      this.data.lastSpecialDeal = date.getTime();
    }
    const n = 48; // 48 hours
    const milliHour = 1000 * 60 * 60 * n; // 48 hours in milli

    const now = new Date().getTime();
    const lastTime = now - this.data.lastSpecialDeal; // Time to last deal
    if (lastTime >= milliHour) { // If past the 48 hour mark
      const offset = Math.floor(lastTime / milliHour) * milliHour; // Boost it to the next 48 hours
      this.data.lastSpecialDeal += offset;
      this.initNewShopSeed(); // Get a new seed when the time ticks over
    }
    const retValue = this.data.lastSpecialDeal + milliHour; // This is the amount of time left to next special deal
    return retValue;
  }

  /**
   * Creates a new shop seed.
   * shopSeed can also be initialized at Shop_Util.getSpecialDeal. That one has more priority but only happens once
   * shopSeed is not important enough to be saved in data, but it is still required, so saved in sessionData
   */
  initNewShopSeed() {
    const day = new Date(this.data.lastSpecialDeal);
    this.sessionData.shopSeed = parseInt(`${day.getFullYear()}${day.getMonth()}${day.getDay()}`);
  }

  /**
   * check if tutorial popup has already been seen
   * @param {string} tutId tutorial ID
   */
  isPopUpTutorialPassed(tutId) {
    if (!this.data.popUpTutorials) {
      this.data.popUpTutorials = [];
    }
    return this.data.popUpTutorials.indexOf(tutId) !== -1;
  }

  /**
   * flag tutorial popup as seen
   * @param {string} tutId tutorial ID
   */
  passPopUpTutorial(tutId) {
    if (!this.data.popUpTutorials) {
      this.data.popUpTutorials = [];
    }

    if (!this.isPopUpTutorialPassed(tutId)) {
      this.data.popUpTutorials.push(tutId);
    }
  }

  /**
   * on Challenge Level passed
   * @param {number} extraStars amount of extra stars received
   */
  passExtraLevel(extraStars) {
    if (!this.data.extraStars) this.data.extraStars = 0;
    this.data.extraStars += extraStars;
    this.save();
  }

  /**
   * On Level passed
   * @param {number} levelIndex index of level passed
   * @param {number} newStars new stars acheived
   * @param {number} newPoints new points acheived
   * @param {bolean} skipReward skip reward application
   * @param {GameEnum} gameMode Challenge or normal mode. Used to be from G.mode
   */
  passLevel(levelIndex, newStars, newPoints, skipReward, gameMode = LevelType.NORMAL) {
    if (this.getStars(levelIndex) === 0 && this.mysteryGift_isModeReady()) {
      this.data.mysteryGift.endOfLastStreak = 0;
    }

    const oldStars = this.getStars(levelIndex);
    const oldPoints = this.getPoints(levelIndex);

    const result = {
      highscore: false,
      points: newPoints,
      reward: SaveStateUtils.computeReward(levelIndex, oldStars, newStars),
      stars: newStars,
      passedFriend: false,
      starImprovement: Math.max(0, newStars - oldStars),
    };

    if (oldPoints < newPoints) {
      this.data.points[levelIndex] = newPoints;
      result.highscore = true;
    }

    if (newStars > oldStars) this.data.levels[levelIndex] = newStars;
    if (!skipReward) this.data.coins += result.reward;

    // tracking
    if (levelIndex === 1) OMT.platformTracking.logFTUEvent('FTUX_Lvl02C');
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.LevelEnd);
    if (gameMode === LevelType.CHALLENGE) OMT.platformTracking.logEvent(OMT.platformTracking.Events.DailyChallengeLevelEnd);

    if (DDNA.tracking.enabled) {
      DDNA.tracking.getDataCapture().addToPlayerCharacterizationSessionParam('levelsPassedThisSession', 1);
      DDNA.transactionHelper.queueLevelCoinReward(result.reward, 'LevelEnd');
      G.sb('onLevelFinished').dispatch(levelIndex, newStars, newPoints);
      DDNA.transactionHelper.sendQueuedLevelCoinRewards();
    } else {
      G.sb('onLevelFinished').dispatch(levelIndex, newStars, newPoints);
    }

    this.save();
    return result;
  }

  /**
   * Takes the regular daily challenge reward and passes it through the progressive stars function and returns it.
   */
  computeDailyChallengeReward() {
    if (G.featureUnlock.progressiveLevelReward) {
      return SaveStateUtils.computeRewardByStarsProgressive(G.saveState.getChallengeStars(), G.lvl.stars, G.json.settings.coinsForStar[2]);
    }
    return G.json.settings.coinsForStar[G.lvl.stars - 1];
  }

  /**
   * call when a level is retried
   * @param {number} lvl_nr Level #
   */
  onLevelRetry(lvl_nr) {
    const levelId = `l_${lvl_nr}`;
    if (this.data.retryCounts == null) this.data.retryCounts = {};
    if (this.data.retryCounts[levelId] == null) this.data.retryCounts[levelId] = 0;
    else this.data.retryCounts[levelId]++;
  }

  /**
   * get the level retry count
   * @param {number} lvl_nr Level #
   */
  getLevelRetries(lvl_nr) {
    const levelId = `l_${lvl_nr}`;
    if (!this.data.retryCounts || !this.data.retryCounts[levelId]) return 0;
    return this.data.retryCounts[levelId];
  }

  /**
   * get the last passed level #
   * @return {number}
   */
  getLastPassedLevelNr() {
    if (this.data !== null && this.data.levels !== null && Object.prototype.hasOwnProperty.call(this.data, 'levels')) {
      return this.data.levels.length;
    }
    return 0;
  }

  /**
   * Is the specified level currently playable?
   * @param {number} lvlNr level #
   * @returns {boolean}
   */
  isLevelAvailable(lvlNr) {
    return lvlNr <= this.data.levels.length;
  }

  /**
   * get points for a level
   * @param {number} lvl_nr Level #
   * @returns {number}
   */
  getPoints(lvl_nr) {
    return this.data.points[lvl_nr] ? this.data.points[lvl_nr] : 0;
  }

  /**
   * get stars for a level
   * @param {number} lvl_nr Level #
   */
  getStars(lvl_nr) {
    return this.data.levels[lvl_nr] ? this.data.levels[lvl_nr] : 0;
  }

  /**
   * get total stars earned
   * @returns {number}
   */
  getAllStars() {
    let val = 0;
    for (let i = 0, len = this.data.levels.length; i < len; i++) {
      val += this.data.levels[i] || 0;
    }

    if (this.data.extraStars === undefined) {
      this.data.extraStars = 0;
    }
    val += this.data.extraStars;
    return val;
  }

  /**
   * get stars the player had when starting the session
   * @returns {number}
   */
  getStarsAtSessionStart() {
    return this.data.starsAtSessionStart;
  }

  /**
   * change the user coin amount
   * @param {number} amount amount of coins
   * @param {boolean} dontSave dont save changes
   * @param {boolean} dispatchDeltaEvent dispatches an event for visual changes. Usually for delta changes
   * @param {boolean} dispatchIncrease dispatch an increase event for record keeping (so far, only daily missions)
   * @param {boolean} trackDDNA Track data for DDNA
   * @param {boolean} dispatchChangeEvent true if we want to dispatch the change event to update fields
   */
  changeCoins(amount, dontSave, dispatchIncrease = true, trackDDNA = true, dispatchChangeEvent = true) {
    if (isNaN(amount)) throw new Error('Error : cannot modfiy coints amount is NaN.');
    this.data.coins = parseInt(this.data.coins) + parseInt(amount); // force amount to be an integer
    if (!dontSave) this.save();
    if (dispatchChangeEvent) G.sb('onCoinsChange').dispatch(this.data.coins);

    // Tracking begins here
    const dataCapture = DDNA.tracking.getDataCapture();
    if (amount > 0) {
      if (dispatchIncrease) { // Increase signal fired here
        G.sb('onCoinsIncrease').dispatch(amount);
      }
      if (DDNA.tracking.enabled && trackDDNA) { // Tracking?
        dataCapture.addToPlayerCharacterizationSessionParam('coinsEarnedThisSession', amount);
      }
    } else if (amount < 0) {
      // track that coins were spent
      if (DDNA.tracking.enabled && trackDDNA) {
        const absAmount = Math.abs(amount);

        dataCapture.addToPlayerCharacterizationParam('coinsSpent', absAmount, false);
        dataCapture.addToPlayerCharacterizationSessionParam('coinsSpentThisSession', absAmount);
        if (this.getLives() === 0) {
          dataCapture.addToPlayerCharacterizationParam('zeroLivesCoinPurchases', 1, false);
        }
        dataCapture.addToPlayerCharacterizationParam('coinPurchasesMade', 1, true);
      }
    }

    this._runningCoinTotal += amount;

    if (trackDDNA) { // More tracking
      // track coin delta
      if (this._runningCoinTotal > 0) {
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.CoinsIn, this._runningCoinTotal, { amount: this._runningCoinTotal });
      } else if (this._runningCoinTotal < 0) {
        const absAmount = Math.abs(this._runningCoinTotal);
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.CoinsOut, absAmount, { amount: absAmount });
      }
    }

    this._runningCoinTotal = 0;
  }

  /**
   * get current coin count
   * @returns {number}
   */
  getCoins() {
    return this.data.coins;
  }

  refreshDailyMissions() {
    G.dailyMissionsMgr._initNewDay();
    game.state.start('World');
  }


  completeDailyMissions() {
    G.dailyMissionsMgr.getGoals().forEach(goal => {
      goal.current = 65;
      goal.status = "completed";
    })
    G.saveState.data.dailyMissions.missions.forEach(mission => {
      mission.current = 65;
      mission.status = "completed"
    });
    G.saveState.save();
    game.state.start('World');
  }

  openWinPopup() {
    const configForPopUp = {
      lvlIndex: 1,
      points: 1000,
      mysteryGiftStreakIncrease: false,
      // treasureHunt: {
      //   collectGems: 0,
      // },
      globalScoreChange: {
        old: 0,
        new: 1000
      }
    };
    G.sb("pushWindow").dispatch(['win', configForPopUp]);
  }

  openDailyChallenge() {
    G.sb("pushWindow").dispatch(['dailyChallenge', G.saveState.getDailyChallengeLevel()]);
  }

  forceShoutout(type, value) {
    if (type === "combo") {
      G.sb("onComboIncrease").dispatch(value);
    } else if (type === "final") {
      G.sb("onGoalAchieved").dispatch();
    } else if (type = "moves") {
      G.sb("forceMoveShoutout").dispatch(value);
    }
  }

  showAllShoutouts() {
    let counter = 1;
    const shoutoutInterval = setInterval(() => {
      switch (counter) {
        case 1:
          G.sb("onComboIncrease").dispatch(3, true);
          break;
        case 2:
          G.sb("onComboIncrease").dispatch(5, true);
          break;
        case 3:
          G.sb("onComboIncrease").dispatch(7, true);
          break;
        case 4:
          G.sb("onComboIncrease").dispatch(9, true);
          break;
        case 5:
          G.sb("onComboIncrease").dispatch(11, true);
          break;
        case 6:
          G.sb("forceMoveShoutout").dispatch(5);
          break;
        case 7:
          G.sb("forceMoveShoutout").dispatch(10);
          break;
        case 8:
          G.sb("onGoalAchieved").dispatch();
          clearInterval(shoutoutInterval);
          break;
      }
      counter++;
    }, 2000);
  }

  openDailyReward(day = 0) {
    var dayToShow = G.Helpers.dailyRewardMgr.getDay(day);
    if (dayToShow !== null) {

      var dailyGifts = dayToShow.getGifts();
      if (dailyGifts) {
        G.WorldMapAppearFlow.flowMgr.onPopUpReqested.dispatch(['dailyReward', dayToShow, function () {
          G.WorldMapAppearFlow.flowMgr.onPopUpReqested.dispatch(['gift', {
            reason: G.GiftUI.Constants.GiftReasons.DailyReward,
            placement: G.BuildEnvironment.adPlacements.doubleDailyReward,
            monetiseType: game.incentivised() && dayToShow.isDoubleable() ? 'double' : false,
            adTracking: {
              requestEvent: 'VideoAdWatchDailyReward',
            },
            twoFrameOpen: G.OMTsettings.elements.gifts.twoFrameOpen,
            resourceTracking: {
              itemType: 'Reward',
              itemId: 'NewDailyReward',
            },
            showGingy: false,
            showTitleBar: false,
            giftBoxType: 'retro',
            customExtraText: '',
            customExtraTextDoubled: '',
            shareable: true,
            autoOpen: true,
            overlay: true,
            autoOpenDelay: 1600,
            coinFeedback: false,
            incentivisedSharing: false,
            skipGiftProcessing: true,
            onlyOneBox: true,
            hideShowMainHighscorePanel: false,
            buttonsOffset: {
              x: 0,
              y: -55,
            },
            gifts: G.Utils.clone(dailyGifts),
          }], undefined, G.WindowMgr.LayerNames.Base, true);
        }], undefined, G.WindowMgr.LayerNames.Base);
      }
    }
  }

  setBoosters() {
    this.data.boosters = this.data.boosters.map(function () {
      return 50;
    });

    this.save();
  }

  /**
   * add minutes to unlimited lifes timer
   * @param {number} min minutes to add to the timer
   * @param {boolean} skipSave skip saving
   */
  addUnlimitedLivesTimeMin(min, skipSave) {
    if (this.data.unlimitedLives !== undefined) {
      if (this.data.unlimitedLives > 0) {
        const difference = Math.max(this.data.unlimitedLives - (this.data.unlimitedLivesStart || Date.now()), 0);
        this.setUserCooldown('unlimitedLives', '', difference);
      }
      delete this.data.unlimitedLives;
      delete this.data.unlimitedLivesStart;
    }

    let currentAmount = this.getUserCooldownRemaining('unlimitedLives', '');
    currentAmount += (min * 60000);
    this.setUserCooldown('unlimitedLives', '', currentAmount, skipSave);

    G.sb('onUnlimitedLivesChanged').dispatch(this.getUnlimitedLivesSec());
    // if (!skipSave) this.save(); // Set cooldown saves
  }

  /**
   * get the unlimited lives seconds remaining
   * @returns {number}
   */
  getUnlimitedLivesSec() {
    if (this.data.unlimitedLives !== undefined) {
      if (this.data.unlimitedLives > 0) {
        const difference = Math.max(this.data.unlimitedLives - (this.data.unlimitedLivesStart || Date.now()), 0);
        this.setUserCooldown('unlimitedLives', '', difference);
      }
      delete this.data.unlimitedLives;
      delete this.data.unlimitedLivesStart;
    }
    // if (!this.data.unlimitedLives) {
    //   this.data.unlimitedLives = 0;
    // }

    // temporary PARTIAL fix for going back in time for unlimited lives
    // if (this.data.unlimitedLivesStart && this.data.unlimitedLivesStart > Date.now()) {
    //   this.data.unlimitedLives = 0;
    //   this.data.unlimitedLivesStart = 0;
    //   this.save();
    //   return 0;
    // }

    const maxMilli = (G.OMTsettings.unlimitedLivesMinCap) * 60000;
    const remaining = this.getUserCooldownRemaining('unlimitedLives', '');
    if (remaining >= maxMilli) {
      this.setUserCooldown('unlimitedLives', '', Math.max(Math.min(remaining, maxMilli), 0), true);
    }
    let sec = Math.round(this.getUserCooldownRemaining('unlimitedLives', '') / 1000);
    sec = Math.max(0, sec);
    return sec;
  }

  /**
   * called when the player loses a life
   * @return {number}
   */
  async loseLife() {
    if (!G.LIVES) return 0;
    if (this.getUnlimitedLivesSec() > 0) return 0;
    if (this.data.lives <= 0) return 0;

    this.data.lives = Math.max(0, this.data.lives - 1);
    this.signals.onLifeAmountChanged.dispatch(this.data.lives);
    this.save();

    if (DDNA.tracking.enabled && this.data.lives <= 0) {
      DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('lastTimeAtZeroLives', Date.now(), true);
    }

    return this.data.lives;
  }

  /**
   * add a life for the user
   * @param {number} nr
   * @param {boolean} skipSave
   * @param {boolean} skipReminder if true, don't schedule game-triggered messages
   */
  async addLife(nr = 1, skipSave = false, skipReminder = false) {
    const scheduledLivesMessages = await OMT.notifications.findGameTriggeredMessages('FullLives');

    // If the number of lives is more than the max,
    // don't change it and just cancel any FullLives messages
    if (this.data.lives >= G.json.settings.livesMax) {
      if (scheduledLivesMessages.length > 0) {
        await OMT.notifications.removeGameTriggeredMessage('FullLives');
      }
      return this.data.lives;
    }

    // Add lives, make sure nr is always at least 1
    this.data.lives = Math.min(this.data.lives + Math.max(nr, 1), G.json.settings.livesMax);

    if (!skipSave) this.save();
    this.signals.onLifeAmountChanged.dispatch(this.data.lives);
    G.sb('onLifeAdded').dispatch(this.data.lives);

    // Cancel pending FullLives message if lives are full
    // Update pending FullLives message timer otherwise (unless skipped)
    if (scheduledLivesMessages.length > 0) {
      if (this.data.lives === G.json.settings.livesMax) {
        await OMT.notifications.removeGameTriggeredMessage('FullLives');
      } else if (!skipReminder) {
        // Calculate time to 5 lives in seconds
        const timeToFullLives = this.getSecUntilFullLives();
        await OMT.notifications.scheduleGameTriggeredMessage(OMT.envData.settings.user.userId, 'FullLives', timeToFullLives, null, false);
      }
    }

    return this.data.lives;
  }

  /**
   * get current lives
   * @returns {number}
   */
  getLives() {
    return this.data.lives;
  }

  /**
   * check if the user has enough coins to buy a item
   * @returns {boolean}
   */
  isEnoughToBuy(amount) {
    return this.data.coins >= amount;
  }

  /**
   * check if the user has enough coins to buy a booster
   * @param {number} boosterNum booster #
   * @returns {boolean}
   */
  isEnoughToBuyBooster(boosterNum) {
    if (this.data.coins >= G.json.settings[`priceOfBooster${boosterNum}`]) {
      return true;
    }
    return false;
  }

  /**
   * get amount of boosters by booster #
   * @param {number} boosterNum booster #
   * @returns {number}
   */
  getBoosterAmount(boosterNum) {
    // eslint-disable-next-line eqeqeq
    if (typeof this.data.boosters[boosterNum] == 'undefined' || this.data.boosters[boosterNum] == null) {
      this.data.boosters[boosterNum] = G.json.settings.boostersOnStart;
    }
    // return booster count
    return parseInt(this.data.boosters[boosterNum]);
  }

  /**
   * check if a booster has been unlocked
   * @param {number} boosterNum booster #
   * @returns {boolean}
   */
  isBoosterUnlocked(boosterNum) {
    const lastPassedLevelNr = this.getLastPassedLevelNr();
    return lastPassedLevelNr + 1 >= G.featureUnlock.unlockLevels.boosters[boosterNum];
  }

  /**
   * attempt to buy a booster with coins.
   * @param {number} boosterNum booster #
   * @param {number} optLevelIndexTracking associated level
   * @param {boolean} skipSave
   */
  buyBooster(boosterNum, optLevelIndexTracking, skipSave = false) {
    const price = G.json.settings[`priceOfBooster${boosterNum}`];
    if (this.data.coins >= price) {
      this.changeCoins(-price, skipSave);
      this.changeBoosterAmount(boosterNum, 1, skipSave);
      this.signals.onBoosterBought.dispatch(boosterNum, price, optLevelIndexTracking);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BoosterIn, 1, {
        booster_id: boosterNum,
        source: 'InGame',
        sum: 1,
      });
      return true;
    }
    return false;
  }

  /**
   * Change inventory count for booster
   * @param {number} boosterNum booster #
   * @param {number} amount amount to increase
   * @param {boolean} skipSave skip inventory saving
   */
  changeBoosterAmount(boosterNum, amount, skipSave) {
    let boosterAmount = (this.getBoosterAmount(boosterNum) * 1) + (amount * 1);
    if (boosterAmount < 0) boosterAmount = 0;
    // for extra moves we set both values together
    if (boosterNum === 5 || boosterNum === 6) {
      this.data.boosters[5] = boosterAmount;
      this.data.boosters[6] = boosterAmount;
    } else {
      this.data.boosters[boosterNum] = boosterAmount;
    }
    if (!skipSave) this.save();
    G.sb('refreshBoosterAmount').dispatch(boosterNum);
  }

  /**
   * fix for users with bugged booster counts. we should probably set a more reasonable cap later.
   */
  enforceBoosterCaps() {
    const maxBoosterCount = 10000;
    let boosterErrorCount = 0;
    for (let i = 0; i < this.data.boosters.length; i++) {
      if (this.data.boosters[i] * 1 > maxBoosterCount) {
        this.data.boosters[i] = maxBoosterCount;
        boosterErrorCount++;
        // eslint-disable-next-line no-restricted-globals
      } else if (isNaN(this.data.boosters[i]) || this.data.boosters[i] * 1 < 0) {
        this.data.boosters[i] = 0;
        boosterErrorCount++;
      }
    }
    // correct booster counts for extra move boosters
    const extraMoveBoosterCount = Math.max(parseInt(this.data.boosters[5]), parseInt(this.data.boosters[6]));
    this.data.boosters[5] = this.data.boosters[6] = extraMoveBoosterCount;
    if (boosterErrorCount > 0) this.save();
  }

  /**
   * use a booster from user inventory
   * @param {number} boosterNum booster #
   * @param {number} optLevelIndexTracking associated level
   */
  useBooster(boosterNum, optLevelIndexTracking, unlimitedMode) {
    // Transaction Tracking
    OMT.transactionTracking.logInventoryTransactionBegin();

    unlimitedMode = unlimitedMode != undefined ? unlimitedMode : false;

    if (this.getBoosterAmount(boosterNum) <= 0) {
      DDNA.transactionHelper.trackBoosterUse(boosterNum, G.json.settings[`priceOfBooster${boosterNum}`]);
      this.buyBooster(boosterNum, optLevelIndexTracking, true);
      G.sfx.cash_register.play();
      OMT.transactionTracking.addInventoryChange('boostersReceived', boosterNum, 1);
      OMT.transactionTracking.addInventoryChange('coins', 0, -G.json.settings[`priceOfBooster${boosterNum}`]);
    } else {
      DDNA.transactionHelper.trackBoosterUse(boosterNum, 0);
    }

    this.changeBoosterAmount(boosterNum, unlimitedMode ? 0 : -1);
    this.signals.onBoosterUsed.dispatch(boosterNum);
    if (DDNA.tracking.enabled) {
      DDNA.tracking.getDataCapture().addToPlayerCharacterizationSessionParam('inGameBoostersUsedThisSession', 1);
    }
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.BoosterOut, 1, {
      booster_id: boosterNum,
      source: 'InGame',
      sum: 1,
    });

    OMT.transactionTracking.addInventoryChange('boostersUsed', boosterNum, 1);
    OMT.transactionTracking.logInventoryTransactionEnd();

    G.sb('onBoosterUsed').dispatch(boosterNum);
  }

  /**
   * use a pre-level booster from user inventory
   * @param {number} boosterNum booster #
   * @param {boolean} isFirstMove true if this is the users first move.
   */
  useStartBooster(boosterNum, isFirstMove, isRequestHelpBoosters) {
    if (!this.data.boosters[boosterNum] && !isRequestHelpBoosters) return;
    if (isFirstMove) {
      DDNA.transactionHelper.trackBoosterUse(boosterNum, 0, isRequestHelpBoosters);
    }
    if (!isRequestHelpBoosters) {
      if (DDNA.tracking.enabled) {
        DDNA.tracking.getDataCapture().addToPlayerCharacterizationSessionParam('mapBoostersUsedThisSession', 1);
      }
      this.changeBoosterAmount(boosterNum, -1);
      this.save();
    }
  }

  /**
   * check consecutive win count
   */
  _checkCWinCountData() {
    if (!this.data.cWinCount) this.data.cWinCount = 0;
    if (!this.data.highestCWinCount) this.data.highestCWinCount = 0;

    // someone quit during level
    if (this.data.cWinCount > 0 && this.data.mysteryGift.duringLevel) {
      this.resetCWinCount();
    }
  }

  /**
   * increment the consecutive win count
   */
  incrementCWinCount() {
    this.data.cWinCount++;
    if (this.data.cWinCount > this.data.highestCWinCount) {
      this.data.highestCWinCount = this.data.cWinCount;
    }
  }

  /**
   * reset the consecutive win count
   */
  resetCWinCount() {
    this.data.cWinCount = 0;
  }

  /**
   * get the consecutive win count
   * @returns {number}
   */
  getCWinCount() {
    return this.data.cWinCount;
  }

  /**
   * get the highest consecutive win count
   * @returns {number}
   */
  getHighestCWinCount() {
    return this.data.highestCWinCount;
  }

  /**
   * get the tresure hunt data
   * @returns {Object}
   */
  getTreasureHuntData() {
    return this.data.treasureHunt;
  }

  /**
   * set and save treasure hunt data
   * @param {Object} data
   */
  saveTreasureHuntData(data) {
    this.data.treasureHunt = data;
    this.save();
  }

  /**
   * create / update the login stats object
   */
  _initLoginStatsTracker() {
    const loginStats = this.getLoginStats();
    loginStats.count++;
    const todayDate = new Date();
    const creationDate = new Date(loginStats.creation);
    const lastLoginDate = new Date(loginStats.lastDate);
    const yesterdaysDate = new Date();
    const daysSinceLastLogin = Math.floor((Date.now() - lastLoginDate) / (1000 * 60 * 60 * 24));
    yesterdaysDate.setDate(todayDate.getDate() - 1);

    // track days since last login
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.DaysSinceLastLogin, 1, {
      source: OMT.envData.entryPoint,
      entry_point: OMT.envData.entryPoint,
      daysSinceLastLogin,
    });

    // check if we are on a diffrent day then the last login
    if (!loginStats.consecutiveLoginDays) loginStats.consecutiveLoginDays = 1;
    if (!SaveStateUtils.isSameDay(todayDate, lastLoginDate)) {
      // increment consecutive login if they logged in yesterday
      if (SaveStateUtils.isSameDay(yesterdaysDate, lastLoginDate)) {
        loginStats.consecutiveLoginDays++;
      } else {
        loginStats.consecutiveLoginDays = 1;
      }
    }
    loginStats.firstDay = creationDate.toDateString() === todayDate.toDateString();
    loginStats.count++;
    if (todayDate.toDateString() !== lastLoginDate.toDateString()) {
      loginStats.dailyCount = 0;
    }
    loginStats.dailyCount++;
    loginStats.lastDate = Date.now();

    this.save();
  }

  /**
   * get login stats object
   * @returns {Object}
   */
  getLoginStats() {
    if (!this.data.loginTrack) {
      this.data.loginTrack = {
        creation: Date.now(),
        count: 0,
        dailyCount: 0,
        consecutiveLoginDays: 1,
        lastDate: Date.now(),
      };
    }
    if (this.data.loginTrack.creation === 0) {
      this.data.loginTrack.creation = Date.now();
    }
    return this.data.loginTrack;
  }

  /**
   * get time in seconds until next free spin
   * @returns {number}
   */
  getSecUntilNextFreeSpin() {
    if (this.data.freeSpin) return 0;
    return Math.floor(((this.data.lastDaily + 86400000) - Date.now()) / 1000);
  }

  /**
   * get time in seconds until next life refill
   * @returns {number}
   */
  getSecUntilNextLifeRefill() {
    if (this.data.lives >= G.json.settings.livesMax) return 0;
    return Math.floor((this._refillRate - (Date.now() - this.data.lastRefillDate)) / 1000);
  }

  /**
   * Calculate time to full lives in seconds
   * @returns {number}
   */
  getSecUntilFullLives() {
    const numLivesMissing = G.json.settings.livesMax - this.data.lives;
    return (numLivesMissing - 1) * (this._refillRate / 1000) + this.getSecUntilNextLifeRefill();
  }

  /**
   * debug / unlock levels on the map
   * @param {number} lvlNr level passed #
   * @param {number} starNr total stars #
   */
  debugStarsUpTo(lvlNr, starNr) {
    this.data.levels = [];
    while (lvlNr--) {
      this.data.levels.push(starNr || 3);
    }
    game.state.start('World');
  }

  /**
   * unlock all gatess
   * @param {number} upTo
   * @param {boolean} goToWorldState
   */
  debugUnlockAllGate(upTo = -2, goToWorldState = true) {
    this.data.gates.slice(0, upTo).forEach((gate) => {
      if (gate) {
        gate.open = true;
      }
    });
    if (goToWorldState) game.state.start('World');
  }

  /**
   * debug / activate mystery gift
   * @param {number} streak streak legnth
   * @param {number} timeLeft duration of mystery gift in seconds
   */
  debugActivateMysteryGift(streak, timeLeft) {
    this.data.mysteryGift = {
      cooldownEndTime: this.setUserCooldown('mysteryGift', '', timeLeft * 1000),
      endOfLastStreak: 0,
      gifts: ['spiral', 'vertical', 'horizontal', 'cross'],
      streak,
      duringLevel: false,
    };
    this.save();
    G.sb('pushWindow').dispatch('mysteryGiftStreakIncrese');
  }

  /**
   * debug / make player ready for mystery gifts
   */
  debugReadyMysteryGift() {
    this.data.mysteryGift = {
      // cooldownEndTime: 0,
      endOfLastStreak: 0,
      gifts: ['spiral', 'vertical', 'horizontal', 'cross'],
      streak: 0,
      duringLevel: false,
    };
    this.save();
  }

  /**
   * debug / give daily reward
   * @param {number} dayNumber number of consecutive days (1-7)
   */
  debugGiveDailyReward(dayNumber) {
    this.data.dailyReward = {
      nextDaily: Math.floor(Date.now() / (24 * 60 * 60 * 1000)),
      currentDay: Math.max(1, Math.min(dayNumber, 7)) - 2,
    };
    this.save();
  }

  /**
   * get the timestamp of a resource sent
   * @param {string} userId user id
   * @param {string} resource resource name
   */
  getResourceSentTimestamp(userId, resource) {
    if (!this.data.resourceSentTimestamp) this.data.resourceSentTimestamp = {};
    if (!this.data.resourceSentTimestamp[userId]) {
      this.data.resourceSentTimestamp[userId] = {};
    }
    return this.data.resourceSentTimestamp[userId][resource] || 0;
  }

  /**
   * set the sent timestamp for a resource
   * @param {string} userId user id
   * @param {string} resource resource name
   */
  setResourceSentTimestamp(userId, resource) {
    this.getResourceSentTimestamp(userId, resource);
    this.data.resourceSentTimestamp[userId][resource] = Date.now();
    this.save();
  }

  /**
   * check if a resource can be sent
   * @param {string} userId user id
   * @param {string} resource resource name
   * @returns {boolean}
   */
  canResourceBeSent(userId, resource) {
    if (G.json.settings && G.json.settings.sendResourceLimitsMin) {
      return this.getSecondsUntilResourceCanBeSent(userId, resource) <= 0;
    }
    return false;
  }

  /**
   * get time in seconds until a resource can be sent
   * @param {string} userId user id
   * @param {string} resource resource name
   * @returns {number}
   */
  getSecondsUntilResourceCanBeSent(userId, resource) {
    const min = G.json.settings.sendResourceLimitsMin[resource];
    if (!min) return 0;
    const lastTime = this.getResourceSentTimestamp(userId, resource);
    return Math.max(0, (lastTime + (min * 60 * 1000) - Date.now()) / 1000);
  }

  /**
   * mark first-time wheel spin
   * @param {boolean} saveNow
   */
  markWheelAsSpun(saveNow = true) {
    this.data.firstTimeWheelSpinner = true;
    if (saveNow) {
      this.save();
    }
  }

  /**
   * check if a message is read
   * @param {string} type typ of message
   * @param {string} id message ID #
   * @returns {boolean}
   */
  isMsgRead(id) {
    const msgTypes = ['payloadGifts', 'acceptedLives', 'acceptedLivesRequests', 'restore',
      'acceptedGateRequests', 'thanksMsg', 'quiz', 'promoReward', 'requestHelpMsg',
      'friendshipChestInvite', 'friendshipChestJoin', 'eventMsg', 'fortuneCookieMsg'];
    let type;

    for (let i = 0; i < msgTypes.length; i++) {
      type = msgTypes[i];
      if (!this.data[type]) this.data[type] = [];
      if (this.data[type].indexOf(id) >= 0) return true;
    }
    return false;
  }

  /**
   * mark a message as read
   * @param {string} type typ of message
   * @param {string} id message ID #
   */
  markMsgAsRead(type, id) {
    if (!this.data[type]) this.data[type] = [];
    this.data[type].push(id);
    this.save();
  }

  /* Mystery Gifts */

  /**
   * create mystery gift data if not set
   */
  _mysteryGift_createData() {
    this.data.mysteryGift = {
      // cooldownEndTime: 0,
      endOfLastStreak: 0,
      gifts: ['spiral', 'vertical', 'horizontal', 'cross'],
      streak: 0,
      duringLevel: false,
    };
  }

  /**
   * check mystery gift data
   */
  _mysteryGift_checkData() {
    if (!this.data.mysteryGift) {
      this._mysteryGift_createData();
    } else {
      // someone quit during level
      if (this.data.mysteryGift.streak > 0 && this.data.mysteryGift.duringLevel) {
        console.log('++ resetting mystery gift streak - duringLevel');
        this.mysteryGift_resetProgress(true, false);
      }
      // gift over
      if (this.data.mysteryGift.streak > 0 && this.mysteryGift_getRemainingGiftCooldown() === 0) {
        console.log('++ resetting mystery gift streak - gift timer over');
        this.mysteryGift_resetProgress(true, false);
      }
    }
  }

  /**
   * get mystery gift current gift list
   * @returns {Array}
   */
  mysteryGift_getCurrentGifts() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    const { streak } = this.data.mysteryGift;
    const { gifts } = this.data.mysteryGift;
    return gifts.slice(0, Math.min(3, streak));
  }

  /**
   * increment the mystery gift streak by 1 (indpeendent of regular win streak counter)
   * @returns {boolean}
   */
  mysteryGift_increaseStreak() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    if (!this.mysteryGift_isModeReady()) return false;
    if (this.data.mysteryGift.streak === 0) {
      Phaser.ArrayUtils.shuffle(this.data.mysteryGift.gifts);
      this.mysteryGift_setGiftCooldown();
    }

    if (this.data.mysteryGift.streak < 4 && this.mysteryGift_getRemainingGiftCooldown() >= 0) {
      this.mysteryGift_setGiftCooldown();
    }

    this.data.mysteryGift.streak++;
    return true;
  }

  /**
   * finish a mystery gift streak
   * @param {*} peak peak streak reached
   */
  mysteryGift_finishStreak(peak) {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    if ((this.data.mysteryGift.streak > 0 || peak) && OMT.feature.getMysteryGiftUnlockByLevel()) {
      console.log('++ resetting mystery gift streak - finished');
      this.mysteryGift_resetProgress(false, false);
    }
  }

  /**
   * check if the mystery gift is ready / available to the user
   */
  mysteryGift_isModeReady() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    if (!OMT.feature.getMysteryGiftUnlockByLevel(true)) { return false; }
    const lastTime = this.data.mysteryGift.endOfLastStreak;
    const cooldown = G.json.settings.mysteryGift.readyCooldownMin * 60 * 1000;
    return Date.now() - lastTime > cooldown;
  }

  /**
   * get the current mystery gift streak
   * @returns {number}
   */
  mysteryGift_getCurrentStreak() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    return this.data.mysteryGift.streak;
  }

  /**
   * update the level for the mystery streak
   */
  mysteryGift_markLevelBeggining() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    this.data.mysteryGift.duringLevel = true;
  }

  /**
   * mark mystery gift level as finished
   */
  mysteryGift_markLevelFinish() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    this.data.mysteryGift.duringLevel = false;
  }

  /**
   * set cool down time for a user for mystery gifts
   */
  mysteryGift_setGiftCooldown() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    if (this.data.mysteryGift.cooldownEnd !== undefined) {
      delete this.data.mysteryGift.cooldownEnd;
    }
    const mysteryGiftData = this.data.mysteryGift;
    mysteryGiftData.endOfLastStreak = 0;
    this.setUserCooldown('mysteryGift', '', G.json.settings.mysteryGift.giftCooldownMin * 60 * 1000);
  }

  /**
   * get mystery gift cooldown time remaining. If no cool down value will be 0
   * @returns {number} duration in milliseconds
   */
  mysteryGift_getRemainingGiftCooldown() {
    if (!this.data.mysteryGift) this._mysteryGift_createData();
    if (this.data.mysteryGift.cooldownEnd !== undefined) {
      delete this.data.mysteryGift.cooldownEnd;
    }
    return this.getUserCooldownRemaining('mysteryGift', '');
  }

  /**
   * reset mystery streak progress
   * @param {boolean} keepStreak
   * @param {number} keepStreakEndTime
   */
  mysteryGift_resetProgress(keepStreak, keepStreakEndTime) {
    if (!this.data.mysteryGift) {
      this._mysteryGift_createData();
      return;
    }

    this.data.mysteryGift.streak = keepStreak ? this.data.mysteryGift.streak : 0;
    this.data.mysteryGift.duringLevel = false;
    this.data.mysteryGift.cooldownEndTime = 0;
    this.data.mysteryGift.endOfLastStreak = keepStreakEndTime ? this.data.mysteryGift.endOfLastStreak : Date.now();
    this.save();
  }

  /* Start of REQUEST HELP */

  /**
   * initializes request help data.
   * @param {boolean} saveNow
   */
  requestHelp_initFriendData(saveNow = false) {
    if (!this.data.requestHelpData) {
      this.data.requestHelpData = {
        friendHelp: 0, // Number of times used
        // friendData: { // Cooldown data managed by user cooldown
        //   SG_bot: this.requestHelp_makeFriendData(),
        // },
        friendInviteSent: new Date(0), // Last time friend invite was sent
        friendAmount: -1, // Last snapshot of how many friends were on the list
        tutorialData: { // Tutorial data
          completions: 0, // The number of times the first step steps are seen
          appearance: 0, // -1 is never, 0 is show now, > 0 is number of levels until it shows
          step: 0, // There are two steps, counting from 0
        },
        uniqueFriends: [], // Unique friends list for tracking on DeltaDNA
        numberOpened: 0, // The number of times Request Help was opened
      };
    }
    if (saveNow) {
      this.save();
    }
  }

  /**
   * resets request help data
   */
  requestHelp_reset() {
    this.data.requestHelpData = undefined;
    this.requestHelp_initFriendData(true);
  }

  /**
   * Sets the user on cooldown. No more requesting help!
   * @param {string} userId
   */
  requestHelp_setOnCooldown(userId, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }

    let duration = 300000; // 5 minutes
    if (this.data.requestHelpData.friendHelp <= 5) { // Number of use before cooldown goes up is 5
      this.data.requestHelpData.friendHelp += 1;
    } else {
      duration = 1200000; // 20 minutes
    }

    if (this.data.requestHelpData.friendData) {
      delete this.data.requestHelpData.friendData; // Removes it
    }
    this.setUserCooldown('requestHelpData', userId, duration);
    if (saveNow) { this.save(); }
  }

  /**
   * Sets the time the friend invite message was sent
   * @param {boolean} saveNow
   */
  requestHelp_sentInvitation(saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    this.data.requestHelpData.friendInviteSent = Date.now();
    if (saveNow) { this.save(); }
  }

  /**
   * Should the Invitation sent message be shown?
   *
   * False = No it should not
   * True = Yes it should
   *
   * These are the conditions that the invitation will not show.
   * 1. When the stored number of friends != number of friends given
   * 2. When 24 hour passes
   * 3. When the button wasn't clicked on in the first place
   * @param {number} friendLength
   * @returns {boolean}
   */
  requestHelp_shouldInvitationShow(friendLength) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    if (friendLength && friendLength !== this.data.requestHelpData.friendAmount) return false;
    if (Date.parse(this.data.requestHelpData.friendInviteSent) === 0) return false;

    const differenceDate = new Date(Date.now() - this.data.requestHelpData.friendInviteSent);
    const epochPlusOne = new Date(0);
    epochPlusOne.setUTCHours(24);
    return differenceDate.getUTCDay() <= epochPlusOne.getUTCDay();
  }

  /**
   * Returns the amount of times requestHelp was used
   * @returns {number}
   */
  requestHelp_getNumOfSpins() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.friendHelp;
  }

  /**
   * Saves the amount of friends last seen
   * @param {number} friendLength
   * @param {boolean} saveNow
   */
  requestHelp_saveFriendAmount(friendLength, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    this.data.requestHelpData.friendAmount = friendLength;
    if (saveNow) { this.save(); }
  }

  /**
   * Returns the amount of friends last seen
   * @returns {number}
   */
  requestHelp_getFriendAmount() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.friendAmount;
  }

  /**
   * Should the tutorial show?
   * @returns {boolean}
   */
  requestHelp_shouldTutorialShow() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.tutorialData.appearance === 0 && this.requestHelp_getTutorialComplete() < 10;
  }

  /**
   * Gets the number of levels that need to be completed before the tutorial reappears
   * @returns {number}
   */
  requestHelp_getTutorialAppearance() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.tutorialData.appearance;
  }

  /**
   * Is this friend unique? Add him in!
   * @param {string} friendID
   * @param {boolean} saveNow
   */
  requestHelp_trackUniqueFriend(friendID, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    if (this.data.requestHelpData.uniqueFriends.indexOf(friendID) === -1) {
      this.data.requestHelpData.uniqueFriends.push(friendID);
    }
    if (saveNow) { this.save(); }
  }

  /**
   * Returns the amount of unique friends. For DeltaDNA
   * @returns {number}
   */
  requestHelp_getUniqueFriendCount() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.uniqueFriends.length;
  }

  /**
   * Sets the required number of completed levels before the tutorial reappears
   * @param {number} newAppearance
   */
  requestHelp_setTutorialReappearance(newAppearance, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    if (this.data.requestHelpData.tutorialData.appearance !== newAppearance) {
      this.data.requestHelpData.tutorialData.appearance = newAppearance;
      if (saveNow) { this.save(); }
    }
  }

  /**
   * Sets the current step of the tutorial
   * @param {number} nextStep
   */
  requestHelp_setTutorialStep(nextStep, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    if (this.data.requestHelpData.tutorialData.step !== nextStep) {
      this.data.requestHelpData.tutorialData.step = nextStep;
      if (saveNow) { this.save(); }
    }
  }

  /**
   * Returns the current step of the tutorial
   * @returns {number}
   */
  requestHelp_getTutorialStep() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    return this.data.requestHelpData.tutorialData.step;
  }

  /**
   * set a request help tutorial as completed
   * @param {number} cycle
   * @param {boolean} saveNow
   */
  requestHelp_setTutorialComplete(cycle, saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    if (this.data.requestHelpData.tutorialData.completions === undefined) { this.data.requestHelpData.tutorialData.completions = 0; }
    this.data.requestHelpData.tutorialData.completions += cycle;
    if (saveNow) { this.save(); }
  }

  /**
   * get # of completed request help tutorials
   * @returns {number}
   */
  requestHelp_getTutorialComplete() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    if (this.data.requestHelpData.tutorialData.completions === undefined) { this.requestHelp_setTutorialComplete(0); }
    return this.data.requestHelpData.tutorialData.completions;
  }

  /**
   * increase # of request help instances opened
   * @param {boolean} saveNow
   */
  requestHelp_increaseOpened(saveNow = true) {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(); }
    if (!this.data.requestHelpData.numberOpened) { this.data.requestHelpData.numberOpened = 0; }
    this.data.requestHelpData.numberOpened++;
    if (saveNow) { this.save(); }
  }

  /**
   * get # of request help instances opened
   * @returns {number}
   */
  requestHelp_getOpened() {
    if (!this.data.requestHelpData) { this.requestHelp_initFriendData(true); }
    if (!this.data.requestHelpData.numberOpened) { this.data.requestHelpData.numberOpened = 0; }
    return this.data.requestHelpData.numberOpened;
  }
  // End of Request Help

  // Start of Friendship Chest
  /**
   * Cards are displayed in order of [Claimed batch] [Claimable Batch] [Friend has joined batch] [Pending Batch] [Invite Friends card] and the last card (which doesn't count)
   * Opened should always be +1 higher than the sum of everything else, unless limit...
   * Think of another way to keep track of things without making it too big of a JSON
   *
   * @param {boolean} saveNow
   */
  friendshipChest_initData(saveNow = false) {
    if (!this.data.friendshipChestData) {
      this.data.friendshipChestData = {};
    }
    this.friendshipChestDataManager.initData(this.data.friendshipChestData);
    if (!this.friendshipChestDataManager.externalSave.has(this.save, this)) {
      this.friendshipChestDataManager.externalSave.add(this.save, this);
    }
    if (saveNow) {
      this.save();
    }
  }

  /**
   * reset friendshipChest data
   */
  friendshipChest_reset() {
    this.data.friendshipChestData = null;
    this.friendshipChest_initData(true);
  }

  // End of Friendship Chest

  /**
   * Creates the fortune cookie data
   */
  async fortuneCookie_initData() {
    if (await OMT.feature.getFortuneCookieEvent(false)) {
      if (!this.data.fortuneCookieData) {
        this.data.fortuneCookieData = {};
      }
      this.fortuneCookieDataManager.initData(this.data.fortuneCookieData);
      if (!this.fortuneCookieDataManager.externalSave.has(this.save, this)) {
        this.fortuneCookieDataManager.externalSave.add(this.save, this);
      }
    }
  }

  /**
   * get the current ask count for the ask friends dialog
   * @returns {number}
   */
  adFallback_askFriends_getAskCount() {
    if (this.data.adFallbackAsk === undefined || this.data.adFallbackAsk.asks === undefined) this.data.adFallbackAsk = { asks: 0 };
    return this.data.adFallbackAsk.asks;
  }

  /**
   * set the ask count for the ask for friends dialog
   * @param {number} count
   */
  adFallback_askFriends_setAskCount(count) {
    if (this.data.adFallbackAsk === undefined || this.data.adFallbackAsk.asks === undefined) this.data.adFallbackAsk = { asks: 0 };
    this.data.adFallbackAsk.asks = count;
    this.save();
  }

  /**
   * set cool down time for a user for adFallback
   * @param {string} cooldownId
   * @param {string} userId
   * @param {string} duration duration in milliseconds
   * @param {boolean} skipSave does not call save if it is true
   */
  setUserCooldown(cooldownId, userId, duration, skipSave = false) {
    if (!this.data.cooldownData) this.data.cooldownData = {};
    const { cooldownData } = this.data;
    const storageId = `${cooldownId}_${userId}`;
    cooldownData[storageId] = Date.now() + duration;
    if (!skipSave) this.save();
  }

  /**
   * get users cooldown time remaining. If no cool down value will be 0
   * @param {string} cooldownId
   * @param {string} userId
   * @returns {number} duration in milliseconds
   */
  getUserCooldownRemaining(cooldownId, userId) {
    if (!this.data.cooldownData) this.data.cooldownData = {};
    const { cooldownData } = this.data;
    const storageId = `${cooldownId}_${userId}`;
    if (!cooldownData[storageId]) return 0;

    const currentTime = Date.now();
    const cooldownEnd = parseInt(cooldownData[storageId]);
    const timeRemaining = cooldownEnd - currentTime > 0 ? cooldownEnd - currentTime : 0;
    if (timeRemaining === 0) delete cooldownData[storageId];
    return timeRemaining;
  }

  /**
   * get seed for a named cooldown
   * @param {string} cooldownId
   * @param {string} duration duration in milliseconds
   * @returns {number}
   */
  getCooldownSeed(cooldownId, duration) {
    if (!this.data.cooldownSeedData) this.data.cooldownSeedData = {};
    const {
      cooldownSeedData,
    } = this.data;
    const storageId = cooldownId;
    if (!cooldownSeedData[storageId]) cooldownSeedData[storageId] = {};
    if (cooldownSeedData[storageId].date < new Date()) {
      cooldownSeedData[storageId].date = Date.now() + duration;
      cooldownSeedData[storageId].seed = Math.random().toString(36).replace(/[^a-z]+/g, '');
    }
    this.save();
    return cooldownSeedData[storageId].seed;
  }

  /**
   * get date of last money spin
   * @return {number}
   */
  getLastMoneySpin() {
    if (this.data.lastMoneySpin === undefined) this.data.lastMoneySpin = 0;
    return this.data.lastMoneySpin;
  }

  /**
   * mark date of last money spin
   */
  markLastMoneySpin() {
    this.data.lastMoneySpin = Date.now();
  }

  /**
   * check if a free money spin is available
   * @returns {boolean}
   */
  isFreeMoneySpinAvailable() {
    return Date.now() - this.getLastMoneySpin() > G.json.settings.freeMoneySpinMinutes * 60000;
  }

  /**
   * check if the bot opt-in gift has been given
   * @returns {boolean}
   */
  wasBotOptInGiftGiven() {
    let wasBotOptInGiftGiven = false;
    if (!this.data.lastBotOptInGiftGiven) {
      wasBotOptInGiftGiven = false;
    } else {
      wasBotOptInGiftGiven = Date.now() - this.data.lastBotOptInGiftGiven < G.json.settings.botOptInGiftResetMinutes * 60000;
    }
    return wasBotOptInGiftGiven;
  }

  /**
   * mark the bot opt-in gift as given to the user
   */
  markBotOptInGiftGiven() {
    this.data.lastBotOptInGiftGiven = Date.now();
    this.save();
  }

  /**
   * set the users bot opt-in state
   * @param {boolean} state
   * @returns {boolean} true if state changed
   */
  setBotOptIn(state) {
    if (this.data.botOptIn == null) this.data.botOptIn = false;
    const stateChanged = state !== this.data.botOptIn;
    this.data.botOptIn = state;
    if (stateChanged) this.save();
    if (DDNA.tracking.enabled) DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('botMessageActive', state ? 1 : 0, true);
    return stateChanged;
  }

  /**
   * get the users bot opt-in state
   * @returns {boolean}
   */
  getBotOptIn() {
    if (this.data.botOptIn == null) this.data.botOptIn = false;
    return this.data.botOptIn;
  }

  /**
   * get the users IAP purchase count
   * @returns {number}
   */
  getIAPCount() {
    if (!this.data.IAPCount) this.data.IAPCount = 0;
    return this.data.IAPCount;
  }

  /**
   * increment the users IAP purchase count
   * @returns {number} current IAP count
   */
  incrementIAPCount() {
    if (!this.data.IAPCount) this.data.IAPCount = 0;
    this.data.IAPCount++;
    this.save();
    G.saveState.sessionData.shopSpecialType = null;
    return this.data.IAPCount;
  }

  /**
   * update save state on tick
   * @param {number} currentTime
   */
  async _onTick(currentTime) {
    if (Date.now() - this.data.lastDaily >= 86400000) {
      this.data.lastDaily = Date.now();
      this.data.freeSpin = true;
      this.save();
      G.sb('onDailyFreeSpinGain').dispatch();
    }

    if (this.data.lives >= G.json.settings.livesMax) {
      this.data.lastRefillDate = Date.now();
    }

    if (this.data.lives < G.json.settings.livesMax) {
      if (this.data.lastRefillDate && this.data.lastRefillDate > currentTime) { // Prevents people from going back in time
        this.data.lastRefillDate = currentTime;
      }
      const diff = currentTime - this.data.lastRefillDate;
      const nrOfLivesToAdd = Math.floor(diff / this._refillRate);
      if (nrOfLivesToAdd > 0) {
        this.data.lastRefillDate += nrOfLivesToAdd * this._refillRate;
        this.addLife(nrOfLivesToAdd, false, true);
      }
      // Just in case going back in time wasn't the issue
      const secLeft = Math.min(Math.round((this._refillRate - (currentTime - this.data.lastRefillDate)) / 1000), (this._refillRate / 1000));
      G.sb('onLifeTimerUpdate').dispatch(secLeft);
    }
  }


  /**
   * restore user progress to a specified level
   * @param {number} levelsCompleted amount of levels completed
   * @param {number} coins
   * @returns {boolean} success state, always seems to be true?
   */
  restoreProgress(levelsCompleted, coins) {
    const saveData = this.data;
    levelsCompleted = Math.max(0, Math.min(levelsCompleted || 0, G.Helpers.levelDataMgr.getNumberOfLevels()));
    saveData.coins += coins;

    const localLevels = saveData.levels;
    if (levelsCompleted > localLevels.length) {
      this._saveStateFixer.fixSaveData(saveData, levelsCompleted, 'remoteLevelsHigherThanLocal');
    }
    this._progressWasRestored = true;
    this.save();
    return true;
  }

  // this is similar to restore progress, but overrides the inventory instead of adding to it
  loadStateChange(levelsCompleted, coins, boosters) {
    const saveData = this.data;

    if (coins) saveData.coins = coins;
    if (boosters) saveData.boosters = boosters;
    if (levelsCompleted) {
      // ensures the levelsCompleted is between 0 and the max number of levels
      levelsCompleted = Math.max(0, Math.min(levelsCompleted || 0, G.Helpers.levelDataMgr.getNumberOfLevels()));

      const localLevels = saveData.levels;
      if (levelsCompleted != localLevels) {
        this._saveStateFixer.fixSaveData(saveData, levelsCompleted, '', true);
      }
    }

    this.save();
    return true;
  }

  /**
   * true if progress was restored this session
   * @returns {boolean}
   */
  get progressWasRestored() {
    return this._progressWasRestored;
  }

  /**
   * Supposed to count the number of times the game has opened
   * I would like it to be flexible for other things but I don't know what else to prepare for
   * For now this will be specific only to OMT_UI_CrossPromoMapButton in OMT_Init.js
   * Its not a session number, but more of a number of times the game has opened
   */
  incrementGameCount() {
    if (this.data.crossPromoCounter === undefined) { this.data.crossPromoCounter = -1; }
    this.data.crossPromoCounter++;
  }

  /**
   * toggle wether hints should be displayed
   * @param {boolean} isOn
   */
  toggleAllowHints(isOn) {
    if (isOn === undefined) {
      isOn = !this.data.allowHints;
    }
    this.data.allowHints = isOn;
    G.sb('stateHintToggled').dispatch(this.data.allowHints);
    this.save();
  }

  /**
   * Gets app-to-user schedule
   */
  getA2USchedule() {
    if (!this.data.a2uSchedule) this.data.a2uSchedule = [];
    return this.data.a2uSchedule;
  }

  /**
   * Stores app-to-user schedule to save state
   * @param {Array} schedule
   */
  setA2USchedule(schedule) {
    this.data.a2uSchedule = schedule;
  }


  /**
   * check if the user migrated from the old COOK version
   * @returns {boolean}
   */

  get migratedFromCook() {
    return this.data.migratedFromCook === true;
  }

  /**
   * save changes to the save state
   */
  async save(saveId = '') {
    if (saveId !== '') console.log(`G.saveState.save(${saveId})`);
    await OMT.userData.writeUserData(DATA_KEY, JSON.stringify(SaveStateUtils.addTimestampToObj(this.data)));
  }
}


/*
     _____                  _____ _        _       _    _ _   _ _
  / ____|                / ____| |      | |     | |  | | | (_) |
 | (___   __ ___   _____| (___ | |_ __ _| |_ ___| |  | | |_ _| |___
  \___ \ / _` \ \ / / _ \\___ \| __/ _` | __/ _ \ |  | | __| | / __|
  ____) | (_| |\ V /  __/____) | || (_| | ||  __/ |__| | |_| | \__ \
 |_____/ \__,_| \_/ \___|_____/ \__\__,_|\__\___|\____/ \__|_|_|___/

*/

/**
 * Utility Class for the save state
 */
class SaveStateUtils {
  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * compute the reward for the level
   * @param {number} lvlIndex index of level passed
   * @param {number} starsBefore previous star amount
   * @param {number} starsAfter current star amount
   */
  static computeReward(lvlIndex, starsBefore, starsAfter) {
    const levelCompleteRewardConfig = G.json.settings.levelCompleteReward;
    let coinReward = 0;
    if (levelCompleteRewardConfig.active) {
      coinReward = SaveStateUtils.computeRewardByLevelComplete(lvlIndex, starsBefore, starsAfter, G.featureUnlock.progressiveLevelReward.enabled);
    } else {
      coinReward = SaveStateUtils.computeRewardByStars(lvlIndex, starsBefore, starsAfter);
    }
    if (G.featureUnlock.progressiveLevelReward.enabled) {
      return SaveStateUtils.computeRewardByStarsProgressive(starsBefore, starsAfter, coinReward);
    }
    return coinReward;
  }

  /**
   * compute level reward by star count
   * @param {number} lvlIndex index of level passed
   * @param {number} starsBefore previous star amount
   * @param {number} starsAfter current star amount
   */
  static computeRewardByStars(lvlIndex, starsBefore, starsAfter) {
    if (starsAfter > starsBefore) {
      const coinsForStars = G.json.settings.coinsForStar;
      return coinsForStars[starsAfter - 1] - (coinsForStars[starsBefore - 1] || 0);
    }
    return 0;
  }

  static computeRewardByStarsProgressive(starsBefore, starsAfter, totalCoins) {
    const { increments } = G.featureUnlock.progressiveLevelReward;
    let result = 0;
    let percent = 0;
    for (let i = starsBefore; i < starsAfter; i++) {
      percent += increments[i];
    }
    result = Math.round(totalCoins * percent);
    return result;
  }

  /**
   * compute complete reward for beating a level
   * @param {number} lvlIndex index of level passed
   * @param {number} starsBefore previous star amount
   * @param {number} starsAfter current star amount
   */
  static computeRewardByLevelComplete(lvlIndex, starsBefore, starsAfter, forceGiveReward = false) {
    const rewardConfig = G.json.settings.levelCompleteReward;
    if ((starsBefore === 0 && starsAfter > 0) || forceGiveReward) {
      const rewardTier = Math.floor(lvlIndex / rewardConfig.increaseEveryNthLevel);
      return rewardConfig.baseLineReward + rewardTier * rewardConfig.rewardIncrease;
    }
    return 0;
  }

  /**
   * add a timestamp to the specified data Object
   * @param {Object} data
   */
  static addTimestampToObj(data) {
    if (Object.prototype.hasOwnProperty.call(data, 'lastChange')) {
      data.lastChange = new Date().getTime();
      return data;
    }
    const newData = {
      lastChange: new Date().getTime(),
    };
    return Object.assign(newData, data);
  }

  /**
   * check if 2 date objects occur on the same date
   * @param {Object} d1 Date instance
   * @param {Object} d2 Date instance
   */
  static isSameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear()
      && d1.getMonth() === d2.getMonth()
      && d1.getDate() === d2.getDate();
  }
}

// create global reference
G.saveState = new SaveState();
